import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "AR/VR Foundations & Immersive Technology Basics",
    description:
      "Introduction to AR ,VR & MR, Key differences and real-world applications, Overview of XR (Extended Reality) ecosystem, How AR/VR is transforming industries: gaming education healthcare architecture, Understanding user experience in immersive environments",
  },
  {
    title: "3D Graphics, Environment Design & Visual Basics",
    description:
      "Introduction to 3D objects textures shaders, Understanding polygons meshes & rendering, Scene creation fundamentals, Lighting materials & visual effects, Designing photorealistic 3D environments",
  },
  {
    title: "Unity/Unreal Engine Fundamentals for AR/VR",
    description:
      "Setting up Unity or Unreal Engine, Interface hierarchy game objects & components, Physics engine basics (colliders rigidbodies), Scene creation & asset management, Building interactive experiences",
  },
  {
    title: "AR Development with ARCore, ARKit & Vuforia",
    description:
      "Marker-based & markerless AR, Plane detection object tracking & surface mapping, Creating AR overlays and interactions, Object placement & real-time AR animations, Mobile AR experience building",
  },
  {
    title: "VR Development & Interaction Systems",
    description:
      "VR devices: Meta Quest HTC Vive Oculus, Designing 360° environments, Teleportation locomotion & hand tracking, Interaction systems: controllers gestures & gaze control, Building immersive VR worlds",
  },
  {
    title: "3D Modeling, Animation & Asset Creation",
    description:
      "Decision-making: if else switch, For while & do-while loops, Break continue & nested structures, Logical programming exercises, Real-world condition-based scenarios",
  },
  {
    title: "Microcontroller Architecture & Interfacing",
    description:
      "Introduction to popular MCUs: 8051 AVR PIC ARM Cortex, Pin configuration internal modules & memory organization, GPIO programming, Interfacing buttons LEDs motors & displays, Hands-on embedded coding for hardware control",
  },
  {
    title: "AR/VR UX Design, Prototyping & User Interaction",
    description:
      "Human-centered design for immersive tech, Field of view motion design & comfort levels, Avoiding VR sickness & usability issues, Creating intuitive AR/VR user journeys, Prototyping with Figma/XR tools",
  },
  {
    title: "Performance Optimization, Testing & Deployment",
    description:
      "Reducing lag & ensuring smooth performance, Texture optimization & draw-call reduction, Testing on different headsets & devices, Packaging & deploying AR/VR apps, Publishing experiences on stores/platforms",
  },
  {
    title: "Capstone AR/VR Project & Career Launchpad",
    description:
      "Building a complete AR or VR product, Workflow: ideation → design → development → testing → deployment, Documentation & presentation for stakeholders, Creating a professional AR/VR portfolio, Interview prep for AR/VR Developer 3D Artist Unity Developer roles",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
